// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleWell_root__MEFqL","borderBottom":"ArticleWell_borderBottom__XGnvh"};